// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"input-search__wrap--3osbm","input":"input-search__input--2R19H","submit":"input-search__submit--36nm2","loader":"input-search__loader--2wh1R"};